import * as api from "../api";
import {
  FETCH_EMPLOYEES,
  ADD_NEW_EMPLOYEE,
  UPDATE_EMPLOYEE,
  START_LOADING,
  END_LOADING,
} from "./constants";

export const getEmployees = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchEmployees();
    dispatch({ type: FETCH_EMPLOYEES, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
    dispatch({ type: END_LOADING });
  }
};

export const createEmployee = (employee, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.addEmployee(employee);
    dispatch({ type: ADD_NEW_EMPLOYEE, payload: data });
    if (openSnackbar) openSnackbar("Employee added successfully");
    return data;
  } catch (error) {
    if (openSnackbar) openSnackbar(error.response?.data?.message || "Error adding employee");
    return null;
  }
};

export const updateEmployeeAction = (id, employee, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateEmployee(id, employee);
    dispatch({ type: UPDATE_EMPLOYEE, payload: data });
    if (openSnackbar) openSnackbar("Employee updated successfully");
    return data;
  } catch (error) {
    if (openSnackbar) openSnackbar(error.response?.data?.message || "Error updating employee");
    return null;
  }
};
